import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-form-section-container',
  template: `
    <div
      class="pt-form-section-container row"
      [ngStyle]="{
        'margin-bottom': marginBottom,
        'padding-top': paddingTop,
        'padding-bottom': paddingBottom
      }"
      [class.justify-content-end]="showHeaderFull"
      [ngClass]="{ 'high-line': showHighLine }"
    >
      <div class="col-2" [class.col-12]="showHeaderFull">
        <span>{{ sectionTitle }}</span>
        <p
          *ngIf="sectionDescription"
          [innerHTML]="sectionDescription"
          class="section-description"
        ></p>
      </div>

      <div class="col-10">
        <ng-content
          class="section-content"
          select="[sectionContent]"
        ></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      .pt-form-section-container {
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        padding-top: 20px;
      }
      .section-description {
        font-size: 11px;
      }

      .high-line {
        border-top: solid 1px var(--ptBorder);
      }

      .pt-form-section-container span {
        font-size: 16px;
      }
    `,
  ],
})
export class FormSectionContainerComponent {
  @Input() sectionTitle = '';
  @Input() sectionDescription?: string;
  @Input() showHighLine = false;
  @Input() showHeaderFull = false;
  @Input() marginBottom = '40px';
  @Input() paddingTop = '20px';
  @Input() paddingBottom = '0px';
}
